import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template", "list"]

  add(event) {
    event.preventDefault()
    const index = Date.now()
    const html = this.templateTarget.innerHTML.replace(/__INDEX__/g, index)
    this.listTarget.insertAdjacentHTML("beforeend", html)
  }

  remove(event) {
    event.preventDefault()
    const row = event.currentTarget.parentElement
    if (!row) return
    const destroyField = row.querySelector("input[name*='_destroy']")
    if (destroyField) {
      destroyField.value = "1"
      // d-none, not style.display: these rows carry Bootstrap's d-flex, which is
      // display:flex !important and beats an inline style. Setting the style left
      // the row on screen looking as though Remove had not worked.
      row.classList.add("d-none")
    } else {
      row.remove()
    }
  }
}
